import { Link } from 'react-router-dom';

import {
  blogPostPath,
  formatBlogDate,
  hasBlogPostImage,
  resolveBlogImageUrl,
  type SbrBlogPostSummary,
} from '../../lib/sbrBlog';

type BlogPostCardProps = {
  post: SbrBlogPostSummary;
  /** Grid index page uses h2; Resources carousel uses h3 */
  titleAs?: 'h2' | 'h3';
  className?: string;
};

export default function BlogPostCard({ post, titleAs = 'h2', className }: BlogPostCardProps) {
  const showImage = hasBlogPostImage(post.imageUrl);
  const TitleTag = titleAs;

  return (
    <article
      className={[
        'resources-blog-card',
        !showImage && 'resources-blog-card--no-image',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Link to={blogPostPath(post.slug)} className="resources-blog-card__link h-100">
        {showImage ? (
          <div className="resources-blog-card__media">
            <img src={resolveBlogImageUrl(post.imageUrl)} alt="" loading="lazy" decoding="async" />
            <span
              className={[
                'resources-blog-card__tag',
                `resources-blog-card__tag--${post.categoryTone}`,
              ].join(' ')}
            >
              {post.categoryLabel}
            </span>
          </div>
        ) : null}

        <div className="resources-blog-card__body">
          {!showImage ? (
            <span
              className={[
                'resources-blog-card__tag',
                'resources-blog-card__tag--inline',
                `resources-blog-card__tag--${post.categoryTone}`,
              ].join(' ')}
            >
              {post.categoryLabel}
            </span>
          ) : null}

          <TitleTag className="resources-blog-card__title">{post.title}</TitleTag>
          <p className="resources-blog-card__excerpt">{post.excerpt}</p>
          <p className="resources-blog-card__meta">
            {formatBlogDate(post.publishedAt)} · {post.readMinutes} min read
          </p>
        </div>
      </Link>
    </article>
  );
}
